import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  ListEffectiveSettingsInput,
  ListEffectiveSettingsVariables,
  ListEffectiveSettingsQueryResponse,
} from '../types';

const listEffectiveSettingsQuery = gql`
  query ListEffectiveSettings($input: ListEffectiveSettingsInput!) {
    payrollListEffectiveSettings(input: $input) {
      code
      success
      message
      settings {
        setting_name
        effective_space
        value
        boolean_value {
          value
        }
        string_value {
          value
        }
        number_value {
          value
        }
        date_range_value {
          value {
            start
            end
          }
        }
        number_range_value {
          value {
            start
            end
          }
        }
        strings_value {
          values
        }
        numbers_value {
          values
        }
        date_ranges_value {
          values {
            start
            end
          }
        }
        number_ranges_value {
          values {
            start
            end
          }
        }
        map_value {
          values
          active_key
        }
        override_applied
        override_id
      }
      pagination {
        page
        page_size
        total_count
        has_next
      }
    }
  }
`;

export const listEffectiveSettings = (
  input: ListEffectiveSettingsInput,
): Promise<ListEffectiveSettingsQueryResponse> => {
  return graphQLApi<ListEffectiveSettingsQueryResponse, ListEffectiveSettingsVariables>({
    query: listEffectiveSettingsQuery,
    queryVariables: {
      input,
    },
  });
};
